import { ErrorBoundary as ReactErrorBoundary, type FallbackProps } from 'react-error-boundary';
import type { ReactNode } from 'react';
import { trackException } from '@/telemetry';
import IncidentPage from '@/pages/states/IncidentPage';
import { pushError } from '@/utils/recentErrors';

function ErrorFallback({ resetErrorBoundary }: FallbackProps) {
  return <IncidentPage onRetry={resetErrorBoundary} />;
}

interface ErrorBoundaryWrapperProps {
  children: ReactNode;
}

export default function ErrorBoundaryWrapper({ children }: ErrorBoundaryWrapperProps) {
  return (
    <ReactErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={(error) => {
        const err = error instanceof Error ? error : new Error(String(error));
        pushError(`UI ${err.name}: ${err.message}`);
        trackException(err);
      }}
    >
      {children}
    </ReactErrorBoundary>
  );
}
